import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import type { TemplateSection } from 'inspection-types';

import { formatSectionTitle } from '../../helpers/inspectionTemplateCustomizeHelpers';

import styles from './InspectionTemplateCustomizeSidebar.scss';

const EMPTY_REMOVED_SECTION_PRESENTATION_IDS = new Set<string>();

type Props = {
  sections: TemplateSection[];
  activeSectionId: string | null;
  onSectionClick: (sectionId: string) => void;
  removedSectionPresentationIds?: ReadonlySet<string>;
};

export function InspectionTemplateCustomizeSidebar({
  sections,
  activeSectionId,
  onSectionClick,
  removedSectionPresentationIds,
}: Props) {
  const removedPresentation =
    removedSectionPresentationIds ?? EMPTY_REMOVED_SECTION_PRESENTATION_IDS;

  const { t } = useTranslation();

  return (
    <aside
      className={styles.sidebar}
      aria-label={t(
        'web.admin.inspections.templateCustomize.sectionsNavLabel'
      )}
    >
      <div className={styles.sidebarTitle}>
        {t('web.admin.inspections.templateCustomize.sectionsSidebarTitle')}
      </div>
      <nav className={styles.sidebarNav}>
        {sections.map(section => (
          <button
            key={section.id}
            type="button"
            className={classNames(
              styles.sidebarButton,
              activeSectionId === section.id && styles.sidebarButtonActive,
              removedPresentation.has(section.id) && styles.sidebarButtonRemoved
            )}
            onClick={() => onSectionClick(section.id)}
          >
            {formatSectionTitle(section.name)}
          </button>
        ))}
      </nav>
    </aside>
  );
}
